import Statistics from './components/pages/Statistics';

import CategoriesIndex from './components/pages/categories/Index';
import CreateCategory from './components/pages/categories/Create';
import EditCategory from './components/pages/categories/Edit';

import UsersIndex from './components/pages/users/Index';
import ViewUser from './components/pages/users/View';

import Settings from './components/pages/Settings';

import CreateSliderImage from './components/pages/slider-images/Create';

import Login from './components/pages/Login';

import OrdersIndex from './components/pages/orders/Index';
import ViewOrder from './components/pages/orders/View';

import ProductsIndex from './components/pages/products/Index';
import CreateProduct from './components/pages/products/Create';
import EditProduct from './components/pages/products/Edit';

import CreateCompanyValue from './components/pages/company-values/Create';
import EditCompanyValue from './components/pages/company-values/Edit';

import NewsIndex from './components/pages/news/Index';
import CreateNews from './components/pages/news/Create';
import EditNews from './components/pages/news/Edit';
import ViewNews from './components/pages/news/View';

import OffersIndex from './components/pages/offers/Index';
import CreateOffers from './components/pages/offers/Create';
import EditOffers from './components/pages/offers/Edit';

import CreateBranchInfo from './components/pages/branch-info/Create';
import EditBranchInfo from './components/pages/branch-info/Edit';

import CouponsIndex from './components/pages/coupons/Index';
import CreateCoupon from './components/pages/coupons/Create';
import EditCoupon from './components/pages/coupons/Edit';

export default [
	{
		name: 'statistics',
		path: '/',
		component: Statistics,
	},

	// Auth

	{
		name: 'login',
		path: '/login',
		component: Login,
	},

	// Settings

	{
		name: 'settings',
		path: '/settings',
		component: Settings,
	},

	// Categories

	{
		name: 'categories',
		path: '/categories',
		component: CategoriesIndex,
	}, {
		name: 'create-category',
		path: '/categories/create',
		component: CreateCategory,
	}, {
		name: 'edit-category',
		path: '/categories/:id/edit',
		component: EditCategory,
	},

	// Products

	{
		name: 'products',
		path: '/products',
		component: ProductsIndex,
	}, {
		name: 'create-product',
		path: '/products/create',
		component: CreateProduct,
	}, {
		name: 'edit-product',
		path: '/products/:id/edit',
		component: EditProduct,
	},

	// Slider Images

	{
		name: 'create-slider-image',
		path: '/settings/company-images/create',
		component: CreateSliderImage
	},

	// Users
	{
		name: 'users',
		path: '/users',
		component: UsersIndex
	},
	{
		name: 'view-user',
		path: '/users/:id',
		component: ViewUser,
	},

	// Orders

	{
		name: 'orders',
		path: '/orders',
		component: OrdersIndex
	},
	{
		name: 'view-order',
		path: '/orders/:id',
		component: ViewOrder
	},

	// Company values

	{
		name: 'create-company-value',
		path: '/company-values/create',
		component: CreateCompanyValue,
	}, {
		name: 'edit-company-value',
		path: '/company-values/:id/edit',
		component: EditCompanyValue,
	},

	// News

	{
		name: 'news',
		path: '/news',
		component: NewsIndex
	}, {
		name: 'create-news',
		path: '/news/create',
		component: CreateNews
	}, {
		name: 'edit-news',
		path: '/news/:id/edit',
		component: EditNews
	}, {
		name: 'view-news',
		path: '/news/:id',
		component: ViewNews
	},

	// Offers
	{
		name: 'offers',
		path: '/offers',
		component: OffersIndex
	},
	{
		name: 'create-offers',
		path: '/offers/create',
		component: CreateOffers,
	},
	{
		name: 'edit-offers',
		path: '/offers/:id/edit',
		component: EditOffers,
	},

	//Branch-info
	{
		name: 'create-branch-info',
		path: '/settings/branchinfo/create',
		component: CreateBranchInfo,
	},
	{
		name: 'edit-branch-info',
		path: '/settings/:id/edit',
		component: EditBranchInfo,
	},


	//Coupons
	{
		name: 'coupons',
		path: '/coupons',
		component: CouponsIndex
	},
	{
		name: 'create-coupon',
		path: '/coupon/create',
		component: CreateCoupon,
	},
	{
		name: 'edit-coupon',
		path: '/coupon/:id/edit',
		component: EditCoupon,
	},
];
